import React from "react";

const Wallpaper = () => {
  return <section className="wallpaper"></section>;
};

export default Wallpaper;
